import {participantsMatcherWorkerFactory as getFilterInstance} from 'common-data-handling';
import appPath from '../../../../misc/appPath';
import {useEventParticipants} from '../useEventParticipants';
import {useEffect, useState} from 'react';

// resolved lazily because setupHistory() runs after this module is evaluated
const workerURL = () => appPath('js/match-participants.webworker.js?v=' + __VERSION__);

/**
 * Returns an array of partially matched participants based on the provided event ID and filter parameters.
 *
 * @param {number} eventId - The ID of the event.
 * @param {object} filterParams - The filter parameters for matching participants.
 * @return {array} An array containing the partially matched participants and a boolean indicating if the filtering is in progress.
 */
export function usePartiallyMatchedParticipants(eventId, filterParams) {
    const participants = useEventParticipants(eventId),
        [output, setOutput] = useState([[], true]);

    useEffect(() => {
        if (filterParams) {
            let waitingResponse = true;
            setOutput(output => [output[0], true]);
            getFilterInstance(workerURL())({participants, filterParams}).then(participants => {
                if (waitingResponse) {
                    setOutput([[...participants]]);
                }
            });
            return () => (waitingResponse = false);
        } else {
            setOutput([[], false]);
        }
    }, [participants, filterParams]);

    return output;
}
